// extracted by css-extract-rspack-plugin
export default {"cls1":"Unibrow-cls1_CE3","cls2":"Unibrow-cls2_a8P Unibrow-cls1_CE3"};